// src/components/DeliveryBanner.js
import React, { useState, useEffect } from 'react';
import { FaTruck, FaGift, FaShieldAlt } from 'react-icons/fa';

const DeliveryBanner = () => {
  const [threshold, setThreshold] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchDeliverySettings();
  }, []);

  const fetchDeliverySettings = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/settings/deliverySettings`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.freeDeliveryThreshold) {
          setThreshold(data.freeDeliveryThreshold);
        }
      }
    } catch (err) {
      console.error('Failed to fetch delivery settings');
    }
  };

  const bannerItems = [
    { icon: FaTruck, text: threshold ? `Free Delivery on orders above ₹${threshold}` : 'Fast & Secure Delivery' },
    { icon: FaGift, text: 'Handcrafted with Love & Care' },
    { icon: FaShieldAlt, text: '100% Quality Guaranteed' },
  ];

  // Rotate banner items
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerItems.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [bannerItems.length]);

  const CurrentIcon = bannerItems[currentIndex].icon;

  return (
    <div className="bg-teal-900 dark:bg-teal-950 text-white py-2.5 relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='none' stroke='%23ffffff' stroke-opacity='0.3' stroke-width='0.5'%3E%3Ccircle cx='30' cy='30' r='20'/%3E%3Ccircle cx='30' cy='30' r='12'/%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-3 text-sm font-medium relative">
          <CurrentIcon className="text-gold-400 animate-pulse-soft flex-shrink-0" />
          <span
            key={currentIndex}
            className="animate-fade-in"
          >
            {bannerItems[currentIndex].text}
          </span>

          {/* Decorative dots */}
          <div className="hidden sm:flex items-center gap-1.5 ml-4">
            {bannerItems.map((_, idx) => (
              <span
                key={idx}
                className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                  idx === currentIndex ? 'bg-gold-400 w-4' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryBanner;
